import get from 'lodash/get';
import { reset } from 'redux-form';

import i18n from 'shared/lib/i18n';

import {
  CLEAR_SERVICE_REQUEST,
  CREATE_SERVICE_REQUEST_FAILURE,
  CREATE_SERVICE_REQUEST_REQUEST,
  CREATE_SERVICE_REQUEST_SUCCESS,
  GET_ITEMS_FOR_EXPORT_SUCCESS,
  GET_SERVICE_REQUESTS_IDS_FAILURE,
  GET_SERVICE_REQUESTS_IDS_REQUEST,
  GET_SERVICE_REQUESTS_IDS_SUCCESS,
  GET_SERVICE_REQUESTS_PRIORITIES_FAILURE,
  GET_SERVICE_REQUESTS_PRIORITIES_REQUEST,
  GET_SERVICE_REQUESTS_PRIORITIES_SUCCESS,
  GET_SERVICE_REQUEST_FAILURE,
  GET_SERVICE_REQUEST_REQUEST,
  GET_SERVICE_REQUEST_STATUSES_FAILURE,
  GET_SERVICE_REQUEST_STATUSES_REQUEST,
  GET_SERVICE_REQUEST_STATUSES_SUCCESS,
  GET_SERVICE_REQUEST_SUCCESS,
  GET_SR_CATEGORIES_FAILURE,
  GET_SR_CATEGORIES_REQUEST,
  GET_SR_CATEGORIES_SUCCESS,
  SERVICE_REQUESTS_COUNTS_FAILURE,
  SERVICE_REQUESTS_COUNTS_REQUEST,
  SERVICE_REQUESTS_COUNTS_SUCCESS,
  SERVICE_REQUESTS_FAILURE,
  SERVICE_REQUESTS_REQUEST,
  SERVICE_REQUESTS_SUCCESS,
  SERVICE_REQUESTS_UNIT_FAILURE,
  SERVICE_REQUESTS_UNIT_REQUEST,
  SERVICE_REQUESTS_UNIT_SUCCESS,
  SERVICE_REQUEST_COMMENTS_REQUESTED,
  SERVICE_REQUEST_UPDATE_REQUESTED,
  SR_CATEGORIES_CREATE_FAILURE,
  SR_CATEGORIES_CREATE_REQUESTED,
  SR_CATEGORIES_CREATE_SUCCESS,
  SR_CATEGORIES_DELETE_FAILURE,
  SR_CATEGORIES_DELETE_REQUEST,
  SR_CATEGORIES_DELETE_SUCCESS,
  SR_CATEGORIES_UPDATE_FAILURE,
  SR_CATEGORIES_UPDATE_REQUEST,
  SR_CATEGORIES_UPDATE_SUCCESS,
} from '../../actionConstants';
import { getBuildingUnits } from '../Building/actionCreators';
import { uploadImage } from '../Visitor/actionCreators';

import { sendGA4Event } from '../Shared/utils/ga';

import apiClient from '../../apiClient';

export const loadSRComments = (
  dispatch,
  serviceRequestId,
  queryParams,
  isExport,
) =>
  dispatch({
    type: SERVICE_REQUEST_COMMENTS_REQUESTED,
    withoutLoading: isExport,
    payload: apiClient.serviceRequest.getComments(
      serviceRequestId,
      queryParams,
    ),
    serviceRequestId,
  });

export const loadServiceRequestAndComments = (
  dispatch,
  serviceRequestId,
  isLoadUnits,
) =>
  dispatch({
    type: GET_SERVICE_REQUEST_REQUEST,
    payload: apiClient.serviceRequest.getById(serviceRequestId).then(
      (res) => {
        dispatch({
          type: GET_SERVICE_REQUEST_SUCCESS,
          res,
        });
        loadSRComments(dispatch, serviceRequestId);
        const buildingId = res?.data?.building;
        if (isLoadUnits && buildingId) {
          getBuildingUnits(dispatch, {}, buildingId);
        }
        if (res?.data?.hasNew) {
          apiClient.serviceRequest.markAsRead({
            serviceRequests: [serviceRequestId],
          });
        }
      },
      (err) => {
        dispatch({
          type: GET_SERVICE_REQUEST_FAILURE,
          err,
        });
      },
    ),
  });

export const clearServiceRequest = (dispatch) =>
  dispatch({ type: CLEAR_SERVICE_REQUEST });

export const updateServiceRequest = (dispatch, data, formName) => {
  const serviceRequestId = get(data, 'serviceRequestId');
  if (!serviceRequestId) {
    return null;
  }
  return dispatch({
    type: SERVICE_REQUEST_UPDATE_REQUESTED,
    payload: apiClient.serviceRequest.changeStatusOrComment(
      serviceRequestId,
      data,
    ),
    isForm: true,
    successMessage: i18n.t('serviceRequest.successMessages.srUpdated'),
    callback: (res) => {
      if (!res) return;
      if (formName) {
        dispatch(reset(formName));
      }
      loadServiceRequestAndComments(dispatch, serviceRequestId);
    },
  });
};

export const getSRCategories = (dispatch, propertyId) =>
  dispatch({
    type: GET_SR_CATEGORIES_REQUEST,
    payload: apiClient.serviceRequest.getSRCategories(propertyId).then(
      (res) => {
        dispatch({
          type: GET_SR_CATEGORIES_SUCCESS,
          res,
          id: propertyId,
        });
        return res?.data;
      },
      (err) =>
        dispatch({
          type: GET_SR_CATEGORIES_FAILURE,
          err,
        }),
    ),
  });

export const createSRCategory = (dispatch, data) =>
  dispatch({
    type: SR_CATEGORIES_CREATE_REQUESTED,
    isForm: true,
    payload: apiClient.serviceRequest.postSRCategories(data).then(
      (res) => {
        dispatch({
          type: SR_CATEGORIES_CREATE_SUCCESS,
          res,
          successMessage: i18n.t(
            'serviceRequest.successMessages.categoryCreated',
          ),
        });
        return res;
      },
      (err) =>
        dispatch({
          type: SR_CATEGORIES_CREATE_FAILURE,
          err,
        }),
    ),
  });

export const updateSRCategory = (
  dispatch,
  data,
  categoryId,
  successMessage = i18n.t('serviceRequest.successMessages.categoryUpdated'),
) =>
  dispatch({
    type: SR_CATEGORIES_UPDATE_REQUEST,
    isForm: true,
    payload: apiClient.serviceRequest.updateSRCategories(data, categoryId).then(
      (res) => {
        dispatch({
          type: SR_CATEGORIES_UPDATE_SUCCESS,
          res,
          successMessage,
        });
        return res;
      },
      (err) =>
        dispatch({
          type: SR_CATEGORIES_UPDATE_FAILURE,
          err,
        }),
    ),
  });

export const deleteSRCategory = (dispatch, categoryId, propertyId) =>
  dispatch({
    type: SR_CATEGORIES_DELETE_REQUEST,
    payload: apiClient.serviceRequest.deleteSRCategory(categoryId).then(
      (res) => {
        dispatch({
          type: SR_CATEGORIES_DELETE_SUCCESS,
          res,
          successMessage: i18n.t(
            'serviceRequest.successMessages.categoryRemoved',
          ),
        });
        return getSRCategories(dispatch, propertyId);
      },
      (err) =>
        dispatch({
          type: SR_CATEGORIES_DELETE_FAILURE,
          err,
        }),
    ),
  });

export const getServiceRequests = (dispatch, queryParams, isExport) =>
  dispatch({
    type: SERVICE_REQUESTS_REQUEST,
    withoutLoading: isExport,
    isTodayCount: queryParams?.todayCount,
    payload: apiClient.serviceRequest.get(queryParams).then(
      (res) => {
        dispatch({
          type: isExport
            ? GET_ITEMS_FOR_EXPORT_SUCCESS
            : SERVICE_REQUESTS_SUCCESS,
          res,
          queryParams,
        });
        return res;
      },
      (err) =>
        dispatch({
          type: SERVICE_REQUESTS_FAILURE,
          err,
        }),
    ),
  });

export const getUnitServiceRequests = (dispatch, queryParams) =>
  dispatch({
    type: SERVICE_REQUESTS_UNIT_REQUEST,
    payload: apiClient.serviceRequest.get(queryParams).then(
      (res) => {
        dispatch({
          type: SERVICE_REQUESTS_UNIT_SUCCESS,
          res,
          queryParams,
        });
        return res;
      },
      (err) =>
        dispatch({
          type: SERVICE_REQUESTS_UNIT_FAILURE,
          err,
        }),
    ),
  });

export const getServiceRequestsCounts = (
  dispatch,
  queryParams,
  option = null,
) => {
  const updatedQueryParams = {
    ...queryParams,
    status: option,
  };
  return dispatch({
    type: SERVICE_REQUESTS_COUNTS_REQUEST,
    payload: apiClient.serviceRequest
      .getServiceRequestsCounts(updatedQueryParams)
      .then(
        (res) =>
          dispatch({
            type: SERVICE_REQUESTS_COUNTS_SUCCESS,
            res,
            option,
          }),
        (err) =>
          dispatch({
            type: SERVICE_REQUESTS_COUNTS_FAILURE,
            err,
          }),
      ),
  });
};

export const createServiceRequest = (dispatch, data, images) =>
  dispatch({
    type: CREATE_SERVICE_REQUEST_REQUEST,
    isForm: true,
    payload: apiClient.serviceRequest.create(data).then(
      async (res) => {
        sendGA4Event('created_service_request');
        dispatch({
          type: CREATE_SERVICE_REQUEST_SUCCESS,
          res,
          successMessage: i18n.t('serviceRequest.successMessages.srCreated'),
        });

        const { id, isAbleToLoadPhoto } = res?.data || {};
        if (images?.length && id && isAbleToLoadPhoto) {
          const url = `service-requests/${id}/photo/`;
          await uploadImage(dispatch, images, url);
        }

        return res;
      },
      (err) => dispatch({ type: CREATE_SERVICE_REQUEST_FAILURE, err }),
    ),
  });

export const getServiceRequestsIds = (dispatch, queryParams) => {
  const { carson_service_requests_ids, ...rest } = queryParams;
  dispatch({
    type: GET_SERVICE_REQUESTS_IDS_REQUEST,
    payload: apiClient.serviceRequest.getServiceRequestsIds(rest).then(
      (res) => {
        dispatch({
          type: GET_SERVICE_REQUESTS_IDS_SUCCESS,
          res,
          queryParams,
        });
        return res;
      },
      (err) =>
        dispatch({
          type: GET_SERVICE_REQUESTS_IDS_FAILURE,
          err,
        }),
    ),
  });
};

export const getServiceRequestsPriorities = (dispatch, buildingId) =>
  dispatch({
    type: GET_SERVICE_REQUESTS_PRIORITIES_REQUEST,
    payload: apiClient.serviceRequest
      .getServiceRequestsPriorities(buildingId)
      .then(
        (res) => {
          dispatch({
            type: GET_SERVICE_REQUESTS_PRIORITIES_SUCCESS,
            buildingId,
            res,
          });
          return res;
        },
        (err) =>
          dispatch({
            type: GET_SERVICE_REQUESTS_PRIORITIES_FAILURE,
            err,
          }),
      ),
  });

export const loadServiceRequestStatusOptions = (dispatch, buildingId) =>
  dispatch({
    type: GET_SERVICE_REQUEST_STATUSES_REQUEST,
    payload: apiClient.serviceRequest.getSRStatuses(buildingId).then(
      (res) => {
        dispatch({
          type: GET_SERVICE_REQUEST_STATUSES_SUCCESS,
          res,
        });
      },
      (err) => {
        dispatch({
          type: GET_SERVICE_REQUEST_STATUSES_FAILURE,
          err,
        });
      },
    ),
  });
